import React, { Suspense } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
/* eslint-disable import/no-unresolved */
import { Analytics } from '@vercel/analytics/react';
/* eslint-enable import/no-unresolved */
import { Grommet } from 'grommet';
import { ResponsiveContext } from 'grommet/contexts';
import {
  ScreenSizeContext, AppThemeProvider,
} from '@Components/Context';
import { AppLoader } from '@Components/Control';
import { fetchAppConfigs } from '@Actions';
import { logCloudwatchError } from '@Helpers/util';
import AppRoutes from './AppRoutes';
import grommetStyles from './styles/grommetStyles';


const Root = () => {
  const dispatch = useDispatch();
  // Get themePreference from Redux state
  const { themeConfig } = useSelector((state) => state.appConfig);
  const themePreference = useSelector((state) => state.auth.themePreference);

  React.useEffect(() => {
    dispatch(fetchAppConfigs());

    // Global error handler, logs to Cloudwatch
    const handleGlobalError = (event) => {
      logCloudwatchError('ERROR', event.message, event.error.stack);
    };

    window.addEventListener('error', handleGlobalError);

    return () => {
      window.removeEventListener('error', handleGlobalError);
    };
  }, []);

  return (
    <Suspense fallback={<AppLoader />}>
      <Grommet theme={grommetStyles}>
        <AppThemeProvider themeConfig={themeConfig} themeState={themePreference}>
          <ResponsiveContext.Consumer>
            {(size) => (
              <ScreenSizeContext.Provider value={{ size }}>
                <Router>
                  <AppRoutes size={size} />
                </Router>
              </ScreenSizeContext.Provider>
            )}
          </ResponsiveContext.Consumer>
          <Analytics />
        </AppThemeProvider>
      </Grommet>
    </Suspense>
  );
};

export default Root;
